import * as actionTypes from './actionTypes'
import { sanitizeSdesFromSdp, modifySdpBandwidth } from '../../callstack/utils'
import { createCodecRemover } from '@kandy-io/sdp-handlers'

/**
 * Add or update a specific key within the store.config.
 *
 * @param {Object} values The values that will be placed in the store.
 * @param {string} [pluginName] The plugin name of the config being set.
 * @return {Action} action A redux action.
 */
export function update (values, pluginName = '') {
  var payload
  // Use the plugin name as a substate key, if present.
  if (pluginName) {
    payload = {
      [pluginName]: values
    }
  } else {
    payload = values
  }

  return {
    type: actionTypes.CONFIG_UPDATE,
    payload: payload
  }
}

/**
 * Updates the SDP Handlers in the call plugin configs
 *
 * @method setSdpHandlers
 * @param {Array<call.SdpHandlerFunction>} sdpHandlers The list of SDP handler to set in the config.
 * @param {Object}                         options     Options to configure extra sdp handlers
 * @returns {Object} A flux standard action.
 */
export function setSdpHandlers (sdpHandlers, options) {
  /*
   * Set SDP handlers to be used for every operation:
   *
   * 1. Application provided SDP handlers.
   *
   * 2. Disable DTLS-SDES crypto method (ie. delete the line) if there's a better
   *    crypto method enabled. WebRTC only allows one method to be enabled.
   *    This is needed for interoperability with non-browser endpoints that include
   *    SDES as a fallback method.
   *
   * 3. [optional] Disable H264 Codecs for video calls, used to reduce SDP size
   *
   * 4. Modify sdp and add bandwidth limits on it if bandwidth controls are provided.
   */
  if (options.removeH264Codecs) {
    sdpHandlers.push(createCodecRemover(['H264']))
  }
  sdpHandlers.push(sanitizeSdesFromSdp)
  sdpHandlers.push(modifySdpBandwidth)

  return {
    type: actionTypes.SET_SDP_HANDLERS,
    payload: {
      sdpHandlers
    }
  }
}
